import type { UUID, ISODateString, Nullable } from './common';

export type QuoteRequestStatus = 'pending' | 'received' | 'no_response';

export interface QuoteRequest {
  id: UUID;
  itemId: UUID;
  vendorName: string;
  sentAt: ISODateString;
  status: QuoteRequestStatus;
  notes: Nullable<string>;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface QuoteRequestWithItem extends QuoteRequest {
  item: {
    id: UUID;
    name: string;
    category: {
      id: UUID;
      name: string;
    };
  };
}

export const QUOTE_REQUEST_STATUS_LABELS: Record<QuoteRequestStatus, string> = {
  pending: 'Pending',
  received: 'Received',
  no_response: 'No Response',
};
